import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProjectStatus } from '../model/project.status';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private httpClient: HttpClient
  ) { }

  getActiveProjects(homeDto: object): Observable<any> {
    const url = `${environment.gateway_url}/getactiveprojects`;
    return this.httpClient.post<ProjectStatus>(url,homeDto).pipe(
      map(item => {
        return item;
      })
    );
  }
  
  GetHomeInformation(homeDto: object): Observable<any> {
    const url = `${environment.gateway_url}/gethomeinformation`;
    return this.httpClient.post<ProjectStatus>(url,homeDto).pipe(
      map(item => {
        return item;
      })
    );
  }
}
